// Copyright © 2022 Olo Inc. All rights reserved.
// This software is made available under the Olo Pay SDK License (See LICENSE.md file)
import { WebPlugin } from '@capacitor/core';
import { PromiseRejectionCode } from './definitions';
// NOTE: This web interface is required by the Capacitor Plugin, but it will not do anything
export class OloPaySDKWeb extends WebPlugin {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    async updateDigitalWalletConfiguration(_options) {
        return Promise.reject({
            code: PromiseRejectionCode.uninmplemented.toString(),
            message: 'updateDigitalWalletConfiguration() is not implemented for web',
        });
    }
    /* eslint-disable @typescript-eslint/no-unused-vars */
    async isDigitalWalletReady() {
        return Promise.reject({
            code: PromiseRejectionCode.uninmplemented.toString(),
            message: 'isDigitalWalletReady() is not implemented for web',
        });
    }
    async createDigitalWalletPaymentMethod(_options) {
        return Promise.reject({
            code: PromiseRejectionCode.uninmplemented.toString(),
            message: 'createDigitalWalletPaymentMethod() is not implemented for web',
        });
    }
    /* eslint-disable @typescript-eslint/no-unused-vars */
    async initialize(_options) {
        return Promise.reject({
            code: PromiseRejectionCode.uninmplemented.toString(),
            message: 'initialize() is not implemented for web',
        });
    }
    isInitialized() {
        return Promise.reject({
            code: PromiseRejectionCode.uninmplemented.toString(),
            message: 'isInitialized() is not implemented for web',
        });
    }
    isDigitalWalletInitialized() {
        return Promise.reject({
            code: PromiseRejectionCode.uninmplemented.toString(),
            message: 'isDigitalWalletInitialized() is not implemented for web',
        });
    }
    /* eslint-disable @typescript-eslint/no-unused-vars */
    initializeInternal(_options) {
        return Promise.reject({
            code: PromiseRejectionCode.uninmplemented.toString(),
            message: 'isDigitalWalletInitialized() is not implemented for web',
        });
    }
}
//# sourceMappingURL=web.js.map